module.exports = __webpack_public_path__ + "img/logo.5f328f7a.png";